<mat-tab-group [@.disabled]="true" [selectedIndex]="0">       
    <mat-tab label="Permissions">
        <div class="full-desc">
            <form [formGroup]="form" (ngSubmit)="submitForm()" novalidate #inputForm>
                <div *ngFor="let permission of permissions; let i=index">
                  <label>
                    <input type="checkbox" class="checkbox" name="{{permission.permission_description}}" [checked]="onCheckPermission(permission.id)" [value]="permission.id" (change)="onCheckboxChange($event)" />
                    <span class="permission-text">{{permission.permission_description}}</span>
                  </label>
                </div>
                <button mat-flat-button color="primary" style="margin:15px" type="submit">Enregister</button>
            </form>
        </div>
    </mat-tab>

    <mat-tab label="Vehicules">
      <div class="full-desc">
        <mat-card class="m-2 p-0">
          <div class="table-wrapper"> 
        
              <table mat-table [dataSource]="dataSource" matSort class="w-100">
              
                  <!-- FullName Column -->
                  <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                      <td mat-cell *matCellDef="let car; let i = index">
                          #{{i+1}}
                          <span *ngIf="car.verification == null" style="color: red; font-size: small;"> EN Attente De Validation</span>
                          <span *ngIf="car.verification == 1" style="color: white; background-color: green; font-size: small;" > Validé </span>
                          <span *ngIf="car.verification == 0" style="color: white; background-color: red; font-size: small;"> Refusé </span>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="marque">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                      <td mat-cell *matCellDef="let car">{{car.mark_lib}} </td>
                  </ng-container>  
                  <ng-container matColumnDef="model">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Modele </th>
                      <td mat-cell *matCellDef="let car">{{car.mod_lib}} </td>
                  </ng-container>
                  <ng-container matColumnDef="prix">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix de location </th>
                      <td mat-cell *matCellDef="let car">{{car.vehicle_price_location}} {{currency}} </td>
                  </ng-container>
      
                  <ng-container matColumnDef="prix_user">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix à percevoir</th>
                      <td mat-cell *matCellDef="let car">{{car.price_to_be_paid}} {{currency}} </td>
                  </ng-container>
      
                  <!-- Username Column -->
                  <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date d'enregistrement </th>
                      <td mat-cell *matCellDef="let car">{{car.created_at}} </td>
                  </ng-container> 
                  <ng-container matColumnDef="status">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Statut</th>
                      <td mat-cell *matCellDef="let car">
                          <div fxLayoutAlign="start start">
                              <div class="rounded mrgn-r-xs success-bg status-icon" *ngIf="car.status=='disponible'"></div>
                              <div class="rounded mrgn-r-xs accent-bg status-icon" *ngIf="car.status'indisponible'"></div>
                              </div>
                              <div class="status-text" *ngIf="car.status=='disponible'">
                                 
                                  <div class="mat-text-muted">disponible</div>
                              </div>
                              <div class="status-text" *ngIf="car.status=='indisponible'">
                               
                                  <div class="mat-text-muted">indisponible</div>
                              </div>
                      </td>
                  </ng-container>
              
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let user; columns: displayedColumns;"></tr>
              </table> 
              <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p> 
          </div>
          <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
      </mat-card>
      </div>
  </mat-tab>



  <mat-tab label="Comme Locataire">
    <div class="full-desc">


      <mat-card class="m-2 p-0">
        <mat-divider></mat-divider>
        <div class="table-wrapper"> 
            <table mat-table [dataSource]="dataSource2" matSort class="w-100">
            
                <!-- Image Column -->
                <ng-container matColumnDef="image">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                    <td mat-cell *matCellDef="let renting">
                        <div *ngIf="renting.image != null">
                          <!-- <img width="60" src={{hostService.getHttpsImage()+renting.image}} class="vehicule"> -->
                            <img width="60" src="" class="vehicule">
                        </div>
                    </td>
                </ng-container>  
    
                <!-- Mark et modèle Column -->
                <ng-container matColumnDef="mark">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                    <td mat-cell *matCellDef="let renting">{{renting.mark_lib}} {{renting.mod_lib}}</td>
                </ng-container> 
        
                <!-- Date Start Column -->
                <ng-container matColumnDef="dateStart">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date départ </th>
                    <td mat-cell *matCellDef="let renting">{{ renting.renting_date_departure | date |titlecase}}</td>
                </ng-container>  
                
                <!-- Date End Column -->
                <ng-container matColumnDef="dateEnd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date retour </th>
                    <td mat-cell *matCellDef="let renting">{{renting.renting_date_return| date |titlecase}}</td>
                </ng-container>   
    
                <!-- Price Column -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix </th>
                    <td mat-cell *matCellDef="let renting">{{renting.renting_price_location}} {{currency}} </td>
                </ng-container> 
    
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                    <td mat-cell *matCellDef="let renting">
                        <span *ngIf="renting.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de Validation</span>
                        <span *ngIf="renting.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Validée</span>
                        <span *ngIf="renting.renting_status == 'REJETER'" style="color:crimson;">Rejetée</span>
                        <span *ngIf="renting.renting_status == 'ANNULER'" style="color: red;">Annulée</span>
                        <span *ngIf="renting.renting_status == 'PAYER'" style="color: rgb(149, 157, 42);">
                            <span *ngIf="renting.renting_date_departure >= currentDate! ; else elseBlock">En Cours</span>
                            <ng-template #elseBlock>Payée</ng-template>    
                        </span>
                        <span *ngIf="renting.renting_status == 'TERMINER'" style="color: rgb(245, 153, 68);">Terminée</span>
                    </td>
                </ng-container> 
                
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let renting">{{renting.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}</td>
                </ng-container> 
    
                <!-- Owner Column -->
                <ng-container matColumnDef="owner">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Propriètaire </th>
                    <td mat-cell *matCellDef="let renting">{{renting.owner_name}} {{renting.owner_surname}}</td>
                </ng-container>
    
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let renting">  
                        <button  (click)="viewRenting(renting.id)"  mat-icon-button  color="accent" matTooltip="De plus détails sur la réservation">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container> 
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                <tr mat-row *matRowDef="let renting; columns: displayedColumns2;"></tr>
            </table> 
            <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Aucune location pour vous</p> 
        </div>
        <mat-paginator [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
    </mat-card>

      </div>
</mat-tab>


<mat-tab label="Comme Propriètaire">
  <div class="full-desc">



    <mat-card class="m-2 p-0">
      <div class="table-wrapper"> 
          <table mat-table [dataSource]="dataSource3" matSort class="w-100">
          
              <!-- Image Column -->
              <ng-container matColumnDef="image">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                  <td mat-cell *matCellDef="let renting">
                      <div *ngIf="renting.image != null">
                        <!-- <img width="60" src={{hostService.getHttpsImage()+renting.image}} class="vehicule"> -->
                          <img width="60" src="" class="vehicule">
                      </div>
                  </td>
              </ng-container>  
  
              <!-- Mark et modèle Column -->
              <ng-container matColumnDef="mark">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                  <td mat-cell *matCellDef="let renting">{{renting.mark_lib}} {{renting.mod_lib}}</td>
              </ng-container> 
      
              <!-- Date Start Column -->
              <ng-container matColumnDef="dateStart">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date départ </th>
                  <td mat-cell *matCellDef="let renting">{{ renting.renting_date_departure | date |titlecase}}</td>
              </ng-container>  
              
              <!-- Date End Column -->
              <ng-container matColumnDef="dateEnd">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date retour </th>
                  <td mat-cell *matCellDef="let renting">{{renting.renting_date_return| date |titlecase}}</td>
              </ng-container>   
  
              <!-- Price Column -->
              <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix </th>
                  <td mat-cell *matCellDef="let renting">{{renting.price_to_be_paid}} {{currency}}</td>
              </ng-container> 
  
              <!-- Status Column -->
              <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                  <td mat-cell *matCellDef="let renting">
                      <span *ngIf="renting.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de Validation</span>
                      <span *ngIf="renting.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Validée</span>
                      <span *ngIf="renting.renting_status == 'REJETER'" style="color:crimson;">Rejetée</span>
                      <span *ngIf="renting.renting_status == 'ANNULER'" style="color: red;">Annulée</span>
                      <span *ngIf="renting.renting_status == 'TERMINER'" style="color: rgb(245, 153, 68);">Terminée</span>
                      <span *ngIf="renting.renting_status == 'PAYER'" style="color: rgb(149, 157, 42);">
                          <span *ngIf="renting.renting_date_departure >= currentDate! ; else elseBlock">En Cours</span>
                          <ng-template #elseBlock>Payée</ng-template>
                      </span>
                  </td>
              </ng-container> 
              
              <!-- Date Column -->
              <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                  <td mat-cell *matCellDef="let renting">{{renting.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}</td>
              </ng-container> 
  
              <!-- Lodger Column -->
              <ng-container matColumnDef="lodger">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Locataire </th>
                  <td mat-cell *matCellDef="let renting">{{renting.lodger_name}} {{renting.lodger_surname}}</td>
              </ng-container> 
      
              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions </th>
                  <td mat-cell *matCellDef="let renting"> 
                      
                      <button  (click)="viewRenting3(renting.id)"mat-icon-button  color="accent" matTooltip="De plus détails sur la réservation">
                          <mat-icon>visibility</mat-icon>
                      </button>
                  </td>
              </ng-container> 
          
              <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
              <tr mat-row *matRowDef="let renting; columns: displayedColumns3;"></tr>
          </table> 
          <p *ngIf="dataSource3 && dataSource3.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
      </div>
      <mat-paginator [pageSizeOptions]="[10, 20, 30, 40, 50]"></mat-paginator>
  </mat-card>
  </div>
</mat-tab>



</mat-tab-group>